import React, { useEffect, useMemo, useState } from 'react';
import { Button, Radio, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { Divider } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { updateRecoveryCameraPage } from '../../../redux/recovery/action';
import { getRecoveryCameraPage } from '../../../redux/recovery/reducer';

export const ADD_METHOD = {
  SINGLE: 1,
  MULTIPLE: 2,
};
const AddMethod = ({ onNext }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(ADD_METHOD.SINGLE);
  const dispatch = useDispatch();
  const { rtspAddMethod } = useSelector(getRecoveryCameraPage);

  useEffect(() => {
    if (rtspAddMethod) {
      setValue(rtspAddMethod);
      onNext(rtspAddMethod);
    }
  }, [onNext, rtspAddMethod]);

  return (
    <div className="add-camera-method">
      <Typography.Paragraph style={{ marginTop: 20, fontSize: 12 }}>
        {t(
          'You can choose to enter information for each camera or import data from an Excel file.',
        )}
      </Typography.Paragraph>

      <Radio.Group
        style={{
          marginTop: 20,
        }}
        onChange={(e) => setValue(e.target?.value)}
        value={value}
      >
        <Space direction="vertical">
          <Radio value={ADD_METHOD.SINGLE}>{t('Enter each camera')}</Radio>
          <Radio value={ADD_METHOD.MULTIPLE}>
            {t('Import from excel file')}
          </Radio>
        </Space>
      </Radio.Group>

      <Divider />

      <div className="btn-next">
        <Button
          type="primary"
          onClick={() => {
            dispatch(updateRecoveryCameraPage({ rtspAddMethod: value }));
            onNext(value);
          }}
        >
          {t('Next')}
        </Button>
      </div>
    </div>
  );
};

export default AddMethod;
